<template>
  <div class="app-evn-costs">
    <span>
      <slot name="txtCostsLastMonth"><p>Kosten <span class="d-none d-md-inline-block">(Verbindungen, Nachrichten & Dienste) </span> im Monat {{lastMonthName}}: {{price(costsLastMonth)}} €</p></slot>
    </span>
    <span>
      <slot name="txtCostsThisMonth"><p>Kosten <span class="d-none d-md-inline-block">(Verbindungen, Nachrichten & Dienste) </span> im aktuellen Monat: {{price(costsThisMonth)}}</p></slot>
    </span>
  </div>
</template>

<script>
import { wrapQuery } from '../../../../../helper/wrapGQLQuery'
import gql from 'graphql-tag'
import price from '@/mixins/price'

export default {
  name: 'EvnCosts',
  data () {
    return {
      currentCustomer: null
    }
  },
  mixins: [
    price
  ],
  computed: {
    costsLastMonth () {
      let summedUpCosts = 0
      const lowerBoundary = new Date()
      lowerBoundary.setDate(1)
      lowerBoundary.setMonth(lowerBoundary.getMonth() - 1)
      const upperBoundary = new Date()
      upperBoundary.setDate(1)
      upperBoundary.setDate(upperBoundary.getDate() - 1)
      const bills = this.currentCustomer?.sortedItemisedBills
      let tempDate
      for (const category in bills) {
        for (const billGroup in bills[category]) {
          if (typeof bills[category][billGroup] === 'object') {
            bills[category][billGroup].forEach((bill) => {
              tempDate = new Date(bill.actionDate)
              if (tempDate > lowerBoundary && tempDate < upperBoundary) {
                summedUpCosts += bill.value
              }
            })
          }
        }
      }
      return summedUpCosts
    },
    costsThisMonth () {
      let summedUpCosts = 0
      const lowerBoundary = new Date()
      lowerBoundary.setDate(1)
      const upperBoundary = new Date()
      const bills = this.currentCustomer?.sortedItemisedBills
      let tempDate
      for (const category in bills) {
        for (const billGroup in bills[category]) {
          if (typeof bills[category][billGroup] === 'object') {
            bills[category][billGroup].forEach((bill) => {
              tempDate = new Date(bill.actionDate)
              if (tempDate > lowerBoundary && tempDate < upperBoundary) {
                summedUpCosts += bill.value
              }
            })
          }
        }
      }
      return summedUpCosts
    },
    lastMonthName () {
      const today = new Date()
      const lastMonthIndex = today.getMonth() - 1
      const months = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']
      return months[lastMonthIndex]
    }
  },
  methods: {
    getFilter () {
      const firstOfLastMonth = new Date()
      firstOfLastMonth.setDate(1)
      firstOfLastMonth.setMonth(firstOfLastMonth.getMonth() - 1)
      const today = new Date()
      return {
        from: this.$config.calendar.formatter.dateFormatter.format(firstOfLastMonth),
        to: this.$config.calendar.formatter.dateFormatter.format(today)
      }
    }
  },
  apollo: {
    itemisedBillsLastTwoMonths: function () {
      return wrapQuery(
        gql`query itemisedBills ($filter: ItemisedBillFilterInput){
          currentCustomer {
            sortedItemisedBills (filter: $filter){
              connectionsInGermany {
                phoneCalls {
                    actionDate
                    value
                }
                sms {
                    actionDate
                    value
                }
                mms {
                    actionDate
                    value
                }
              }
              connectionsFromGermany {
                phoneCalls {
                    actionDate
                    value
                }
                sms {
                    actionDate
                    value
                }
                mms {
                    actionDate
                    value
                }
              }
              connectionsAbroad {
                 phoneCalls {
                    actionDate
                    value
                }
                sms {
                    actionDate
                    value
                }
                mms {
                    actionDate
                    value
                }
              }
              other {
                other {
                    actionDate
                    value
                }
                serviceCalls {
                    actionDate
                    value
                }
              }
            }
          }
        }`, this, 'currentCustomer', {
          filter: this.getFilter()
        }
      )
    }
  }
}
</script>
